import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Reserva de Documento Escola",
  path: "/biblioteca/bibemprestimousuario/reserva/1/:bibTipoUsuarioId/:segUsuarioId",
  parent: "bibemprestimoescola",
  name: "bibreserva_grid_escola",
  component: () => import("@/views/biblioteca/bibreserva/components/GridIndex.vue"),
  meta: {
   permissions: [eTipoPermissao.BIB_RESERVAESCOLANOVO_MENU_1300400199],
  },
  goesToMenu: false,
 },
 {
  description: "Reserva de Documento Central",
  path: "/biblioteca/bibemprestimousuario/reserva/0/:bibTipoUsuarioId/:segUsuarioId",
  parent: "bibemprestimocentral",
  name: "bibreserva_grid_central",
  component: () => import("@/views/biblioteca/bibreserva/components/GridIndex.vue"),
  meta: {
   permissions: [eTipoPermissao.BIB_RESERVACENTRALNOVO_MENU_1300400159],
  },
  goesToMenu: false,
 },
];
